import React from 'react';
import { Location as ServiceLocation } from '../../../../utils/mappers/service.mapper';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { LocationDataHooks } from './dataHooks';
import Text, { TextType } from '../../Text/Text';
import { LocationType } from '@wix/ambassador-availability-calendar/types';
import { TFunction } from '../../../../types/types';
import { TagName } from '../../../../utils/tagName.const';

export interface LocationProps {
  location: ServiceLocation;
}
const Location: React.FC<LocationProps> = ({ location }) => {
  const { t } = useTranslation();
  const locationText = getLocationText(location, t);

  return (
    <Text
      type={TextType.Secondary}
      data-hook={LocationDataHooks.LOCATION}
      tagName={TagName.Paragraph}
    >
      {locationText}
    </Text>
  );
};

const getLocationText = (location: ServiceLocation, t: TFunction): string => {
  switch (location?.locationType) {
    case LocationType.OWNER_BUSINESS:
      return location?.name!;
    case LocationType.OWNER_CUSTOM:
      return location?.address!;
    case LocationType.CUSTOM:
      return t('app.booking-details.locations.client-place.text');
    default:
      return '';
  }
};

export default Location;
